import { SetLog, TagLogs } from "../../../logs/set-log";

export function getApiStatusError(message, data) {
  SetLog(
    TagLogs.error_dispath_hook_update,
    {
      msg: message,
      data,
    },
    false
  );
  return {
    status: false,
    message: message ?? [],
    data: data ?? [],
  };
}

export function getApiStatusSuccess(message, data) {
  return {
    status: true,
    message: message ?? [],
    data: data ?? [],
  };
}

export function getErrorMessageFromError(error) {
  const errorMessage =
    err?.message || err?.response?.data?.message || "Erro desconhecido";
  return errorMessage;
}
